import {useState} from 'react';
import {Toast} from '@shopify/polaris';

/**
 * A one-shot Toast for a post-redirect-get success notice (?ok=). Polaris's
 * Toast registers with Frame only via a client effect and renders null into
 * markup, so SSR and hydration stay byte-identical and the notice simply
 * appears once app.js lands. Errors stay as persistent Banners — a toast that
 * auto-dismisses is the wrong gravity for them.
 *
 * Must render inside an <AppFrame> (the Toast speaks to Frame context).
 */
export function NoticeToast({notice}: {notice?: string | null}) {
  const [visible, setVisible] = useState(true);
  if (!notice || !visible) return null;
  return <Toast content={notice} onDismiss={() => setVisible(false)} />;
}
